module.exports = __webpack_public_path__ + "static/media/temable-close.c045bbb8.svg";